import React, { useContext } from 'react';
import T from '../../../../common/components/T';
import { A, svgSprite } from '../../../../hybrid/wrappers';
import { TooltipsContext } from '../../../../common/decorators/Tooltips';
import css from './FinPasswordTooltip.module.scss';
import Language from '../../../../common/decorators/Language';
import classNames from 'classnames';
import { useWidgetTranslates } from '../../../../common/utils/utils';
import SingleButton from '../../../../widgets/form/form-control-buttons/SingleButton/SingleButton';

const FinPasswordTooltip = ({ translates, classes }) => {
    const { handleSetTooltipFlag } = useContext(TooltipsContext);
    const trans = useWidgetTranslates('finPasswordTooltip');
    return (
        <Language page={'/office'} translates={translates}>
            <div className={classNames(css.finPassTooltipBlock, classes?.finPassTooltipBlock || '')}>
                <div className={css.finPassTooltipIcon}>{svgSprite('question-circle-fill', { className: 'tooltipShadow' })}</div>
                <div>
                    <div>
                        <span>
                            <T
                                textName='wallets-FinPasswordTooltip'
                                defaultStr='Если вы ранее не меняли финансовый пароль, то он соответствует основному паролю, который вы указали при регистрации. Изменить финансовый пароль можно в'
                                page={'widget'}
                                customTranslates={trans}
                                group={'finPasswordTooltip'}
                            />
                        </span>{' '}
                        <A href='/profile'>
                            <T
                                defaultStr={'«Профиле»'}
                                textName='finPasswordTooltipText'
                                page={'widget'}
                                customTranslates={trans}
                                group={'finPasswordTooltip'}
                            />
                        </A>
                    </div>
                    <SingleButton
                        type='cancel'
                        buttonText={
                            <T
                                textName='finPassBlockBtnForHideText'
                                defaultStr='Понятно, больше не показывать'
                                page={'widget'}
                                customTranslates={trans}
                                group={'finPasswordTooltip'}
                            />
                        }
                        clickFunc={() => handleSetTooltipFlag('finPassTooltip', false, true)}
                        customButton={{
                            singleButton: css.finPassBtn,
                            butWrapper: css.finPassBtnInner
                        }}
                    />
                </div>
                {/* <button
                    onClick={() => {
                        handleSetTooltipFlag('finPassTooltip', false, true);
                    }}
                    className={classNames(css.finPassTooltipBlockBtnForHide, classes?.finPassTooltipBlockBtnForHide || '')}
                >
                    <p className={css.finPassTooltipBlockBtnForHideText}>
                        <T
                            textName='finPassBlockBtnForHideText'
                            defaultStr='Понятно, больше не показывать'
                            page={'widget'}
                            customTranslates={trans}
                            group={'finPasswordTooltip'}
                        />
                    </p>
                </button> */}
            </div>
        </Language>
    );
};
export default FinPasswordTooltip;
